import { combineReducers } from 'redux-immutable';
import { routerReducer } from 'react-router-redux';

import auth from 'redux/auth/reducer';
import accounts from 'redux/accounts/reducer';
import buyers from 'redux/buyers/reducer';
import chats from 'redux/chats/reducer';
import contacts from 'redux/contacts/reducer';
import credits from 'redux/credits/reducer';
import goods from 'redux/goods/reducer';
import mails from 'redux/mails/reducer';
import marketPlace from 'redux/marketPlace/reducer';
import members from 'redux/members/reducer';
import messages from 'redux/messages/reducer';
import options from 'redux/options/reducer';
import orderItems from 'redux/orderItems/reducer';
import orders from 'redux/orders/reducer';
import products from 'redux/products/reducer';
import sellers from 'redux/sellers/reducer';
import shop from 'redux/shop/reducer';
import storeItems from 'redux/storeItems/reducer';
import transactions from 'redux/transactions/reducer';
import ui from 'redux/ui/reducer';
import users from 'redux/users/reducer';
import notifications from 'redux/notifications/reducer';
import socialContacts from 'redux/socialContacts/reducer';

const rootReducer = combineReducers({
  routing: routerReducer,
  auth,
  accounts,
  buyers,
  contacts,
  credits,
  goods,
  mails,
  marketPlace,
  members,
  messages,
  options,
  orderItems,
  orders,
  chats,
  products,
  sellers,
  shop,
  storeItems,
  transactions,
  ui,
  users,
  notifications,
  socialContacts,
});

export default rootReducer;
